module.exports = __webpack_public_path__ + "img/hero.345c2117.svg";